import Model from "~/models/_Model";

export default class ContactPerson extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "contacts";
  }

  relations() {
    return {};
  }

  primaryKey() {
    return "username";
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
}
